<template>
    <div>

        <div>
            <div v-if="showComponent" class="alert alert-warning ng-cloack">
                <span class="show">
                    <translate>You did not set up your payment details. If you want to remain premium after</translate> {{ subscription.get_end_date| formatDate }} <translate>please add a new one.</translate>
                </span>
                <h4 v-if="!isPaymentDetailsContainer" class="alert-link add-new-payment-text" @click="makeNewPayment"><font-awesome-icon icon="fa-solid fa-plus" /><translate>Add payment details</translate></h4>
            </div>

            <div v-if="isPaymentDetailsContainer">
                <GekkoButton 
                    @click="makeNewPayment"
                    :text="$gettext('Add payment details')"
                    variant="outline-primary"
                    v-b-tooltip.hover="{
                        title: $gettext('Please note that it takes a while to update your payment details. If you added new payment details it can take up to several hours to be reflected in your account.'),
                    }"
                />
                <div v-if="paymentDetails.data">
                    <!-- FRONTEND_AUDIT -->
                    <div v-for="a_token in paymentDetails.data.tokens" :key="a_token.token">
                        <div class="text-dark bg-light border p-3 mt-3 mr-10 ml-10">
                            <div>
                                <translate>IBAN:</translate>&nbsp;
                                {{ a_token.display }}
                            </div>
                            <div>
                                <translate>Account owner:</translate>&nbsp;
                                {{ a_token.name_holder }}
                            </div>
                            <div>
                                <translate>Is expired:</translate>&nbsp;
                                <span v-if="a_token.expired"><translate>Yes</translate></span>
                                <span v-else><translate>No</translate></span>
                            </div>
                            <GekkoButton 
                                @click="deactivatePayment(a_token.token)"
                                :text="$gettext('Deactivate')"
                                variant="outline-primary"
                                class="m-1"
                            />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-for="(paymentDetail, key) in paymentDetails.details" :key="key">
                        <div class="text-dark bg-light border p-3 mt-3 mr-10 ml-10">
                            <div v-if="paymentDetail.RecurringDetail['bank']">
                                <div>
                                    <translate>Bank:</translate>
                                    {{ paymentDetail.RecurringDetail['bank']['bankName'] }}
                                    <span class="float-right" v-show="paymentDetail.RecurringDetail.default" v-translate>default payment</span>
                                </div>
                                <div>
                                    <translate>Account owner:</translate>
                                    {{ paymentDetail.RecurringDetail['bank']['ownerName'] }}
                                </div>
                                <div>
                                    <translate>IBAN:</translate>
                                    {{ paymentDetail.RecurringDetail["bank"]["iban"] }}
                                </div>
                                <div>
                                    <translate>Method:</translate>
                                    {{ paymentDetail.RecurringDetail["variant"] }}
                                </div>
                                <div>
                                    <translate>Country code:</translate>
                                    {{ paymentDetail.RecurringDetail["bank"]["countryCode"] }}
                                </div>
                            </div>
                            <div v-if="paymentDetail.RecurringDetail['card']">
                                <div>
                                    <translate>Card holder:</translate>
                                    {{ paymentDetail.RecurringDetail['card']['holderName'] }}
                                    <span class="float-right" v-show="paymentDetail.RecurringDetail.default" v-translate>default payment</span>
                                </div>
                                <div>
                                    <translate>Card number:</translate>
                                    **** **** **** {{ paymentDetail.RecurringDetail['card']['number'] }}
                                </div>
                                <div>
                                    <translate>Expire date:</translate>
                                    {{ paymentDetail.RecurringDetail['card']['expiryMonth']}}/{{ paymentDetail.RecurringDetail['card']['expiryYear']}}
                                </div>
                            </div>
                            <div>
                                <translate>Creation Date:</translate>
                                {{ paymentDetail.RecurringDetail["creationDate"]| formatDate }}
                            </div>
                            <GekkoButton 
                                @click="deactivatePayment(paymentDetail.RecurringDetail)"
                                :text="$gettext('Deactivate')"
                                variant="outline-primary"
                                class="m-1"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    import BillingSettingService from "@/store/services/billingsetting.service";
    import GekkoButton from "@/components/GekkoButton";

    export default {
        name: "AddPaymentNotification",
        components: { GekkoButton },
        data() {
            return {
                subscription: {},
                paymentDetails: {}
            }
        },
        props: {
            container: {
                type: String,
                default: "banner"
            }
        },
        created() {
            this.setupData()
        },
        methods: {
            setupData () {
                this.detailsLoaded = false;
            
                console.log('BillingSettingService starting')
                BillingSettingService.retrieveCurrent().then((response)=>{
                console.log(response.data);
                })
                // this.subscriptionEndsInAWeek = (Date.compare(Date.parse(this.subscription.get_end_date), Date.today().add(7).days()) != 1);
                BillingSettingService.getPaymentMethods().then((response) => {
                    this.paymentDetails = response.data;
                    if (response.data) {
                        this.paymentDetails.details[0].RecurringDetail.default = true;
                    }
                    this.detailsLoaded = true;
                });
            },
            makeNewPayment() {
              BillingSettingService.addPaymentMethods().then((response)=>{
                if (window.mixpanel) {
                    window.mixpanel.track("Subscriptions: change payment details", {
                        'started on page': location.href
                    });
                 }
                this.$router.push({ name: 'ConfirmPayment', params: { transactionId: response.data } });
              })
            },
            deactivatePayment(paymentDetails) {
                BillingSettingService.deactivatePaymentMethod({ recurringDetailReference: paymentDetails.recurringDetailReference })
                    .then(this.setupData());
            },
        },
        computed: {
            showComponent() {
                return this.subscription.is_valid && this.detailsLoaded && !this.paymentDetails && this.subscriptionEndsInAWeek;
            },
            isPaymentDetailsContainer() {
                return this.container === "paymentDetails";
            },
        }
    }
</script>

<style scoped>
    .add-new-payment-text {
        cursor: pointer;
    }
</style>